/**
 * Connected-channel menu targets.
 * Conversation links are copied, never opened.
 * Messenger copies a Facebook Page link built from the stored page id.
 */

/** Digits-only wa.me link. A number with no digits has no reliable link. */
export function whatsAppConversationUrl(phoneNumber: string | null | undefined): string | null {
  if (!phoneNumber) return null;
  const digits = phoneNumber.replace(/\D/g, "");
  if (digits.length === 0) return null;
  return `https://wa.me/${digits}`;
}

/** Documented ig.me thread link. A blank handle has no reliable link. */
export function instagramConversationUrl(username: string | null | undefined): string | null {
  if (!username) return null;
  const handle = username.trim().replace(/^@+/, "");
  if (handle.length === 0) return null;
  return `https://ig.me/m/${handle}`;
}

/** Public Instagram profile for the stored handle. A blank handle has no profile URL. */
export function instagramProfileUrl(username: string | null | undefined): string | null {
  if (!username) return null;
  const handle = username.trim().replace(/^@+/, "");
  if (handle.length === 0) return null;
  return `https://www.instagram.com/${handle}`;
}

/** Facebook Page link from the stored page id. A blank id has no Page URL. */
export function facebookPageUrl(pageId: string | null | undefined): string | null {
  if (!pageId) return null;
  const id = pageId.trim();
  if (id.length === 0) return null;
  return `https://www.facebook.com/${encodeURIComponent(id)}`;
}

/**
 * One list menu is open. Opening replaces the active id.
 * A close from the menu that just lost ownership must leave the new one open.
 */
export function nextOpenMenuId<T extends string>(
  current: T | null,
  id: T,
  open: boolean,
): T | null {
  if (open) return id;
  return current === id ? null : current;
}

export async function writeClipboardText(value: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(value);
    return true;
  } catch {
    return false;
  }
}
